import API from '.';

export default class PrimaryUseType {
  /**
   * The primaryUseType dimension table for UDM
   * @param {number} primaryUseTypeId Id of the primaryUseType.
   * @param {string} primaryUseTypeName Name of the primaryUseType.
   * @param {number} primaryUseTypeParentId Id of the primaryUseType parent.
   * @param {string} isAssignable 'S' for site, 'L' for location, 'B' for building.
   * @param {string} isActive 'Y' for active, 'N' for inactive.
   */
  constructor({
    primaryUseTypeId,
    primaryUseTypeName,
    primaryUseTypeParentId,
    isAssignable,
    isActive
  }) {
    this.primaryUseTypeId = primaryUseTypeId;
    this.primaryUseTypeName = primaryUseTypeName;
    this.primaryUseTypeParentId = primaryUseTypeParentId;
    this.isAssignable = isAssignable;
    this.isActive = isActive.toLowerCase() === 'y' ? true : false;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get("/primaryUseType");
    return data.map((d) => new PrimaryUseType(d));
  }

  static async get(id) {
    const api = await API();
    const { data } = await api.get(`primaryUseType/${id}`);
    return new PrimaryUseType(data);
  }

  // static async create(data) {
  //   const api = await API();
  //   console.log(data);
  //   const { res } = await api.post('primaryUseTypeType', data);
  //   return res;
  // }

  // static async update (id, data) {
  //   const api = await API();
  //   const { res } = await api.put(`/primaryUseTypeType`, data);
  //   return res;
  // }
}
